module.exports = __webpack_public_path__ + "img/uk_success_7.93da17c6.png";